import { IGptConfigurationEx } from '../models/GptConfigurationEx';
import { GptConfigurationsAction } from '../actions/gptConfigurationsAction';

export const gptConfigurationsReducer = (gptConfigurations: IGptConfigurationEx[], action: GptConfigurationsAction): IGptConfigurationEx[] => {
    switch (action.type) {
        case 'SET_GPT_CONFIGURATIONS':
            return [...action.payload];
        case 'ADD_GPT_CONFIGURATION':
            return [...gptConfigurations, action.payload];
        case 'DELETE_GPT_CONFIGURATION':
        case 'UNSUBSCRIBE_GPT_CONFIGURATION':
            return gptConfigurations.filter(x => x.id !== action.payload);
        case 'EDIT_GPT_CONFIGURATION':
            return gptConfigurations.map(x => x.id === action.payload.id ? action.payload : x);
        case 'EDIT_GPT_CONFIGURATIONS':
            return gptConfigurations.map(x => action.payload.some(y => y.id === x.id) ? action.payload.find(y => y.id === x.id)! : x);
        default:
            return gptConfigurations;
    }
};
